// extracted by mini-css-extract-plugin
export default {"followSearchText":"_e1f09480","searchName":"_f23132ab"};